module.exports = __webpack_public_path__ + "img/02_overlay.8f042d06.png";